import { Component } from '@theme/component';

class ProductSelectorComponent extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.buttons = [...this.querySelectorAll('[data-prodrow-model]')];
    this.buy = this.querySelector('[data-prodrow-buy]');
    this.buyLabel = this.querySelector('[data-prodrow-buy-label]');
    this.specs = this.querySelector('[data-prodrow-specs]');
    this.specSets = [...this.querySelectorAll('[data-prodrow-spec-set]')];
    this.buttons.forEach((btn, i) => btn.addEventListener('click', () => this.select(i)));
    if (this.buttons.length) this.select(0);
    if (this.specs) {
      this.resizer = new ResizeObserver(() => this.fitSpecs());
      this.resizer.observe(this);
    }
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.resizer?.disconnect();
  }

  #altezza(set) {
    const last = set?.lastElementChild;
    if (!set || !last) return 0;
    return Math.round(last.getBoundingClientRect().bottom - set.getBoundingClientRect().top);
  }

  fitSpecs() {
    if (!this.specs || !this.specSets.length) return;
    const passo = Math.max(...this.specSets.map((s) => this.#altezza(s)));
    if (passo > 0) this.style.setProperty('--set-h', `${passo}px`);
    this.specs.style.blockSize = `${this.#altezza(this.specSets[this.current])}px`;
  }

  select(i) {
    this.current = i;
    this.style.setProperty('--i', i);
    this.buttons.forEach((btn, j) => {
      btn.classList.toggle('is-active', i === j);
      if (i === j) {
        btn.setAttribute('aria-current', 'true');
      } else {
        btn.removeAttribute('aria-current');
      }
    });
    const active = this.buttons[i];
    if (this.buyLabel) {
      this.buyLabel.textContent = `${this.dataset.buyPrefix || ''} ${active.dataset.prodrowName || ''}`.trim();
    }
    if (this.buy && active.dataset.prodrowUrl) {
      this.buy.setAttribute('href', active.dataset.prodrowUrl);
    }
    this.fitSpecs();
  }
}

if (!customElements.get('product-selector-component')) {
  customElements.define('product-selector-component', ProductSelectorComponent);
}
